import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";
import { LANGUAGES, DEFAULT_LANGUAGE } from "../i18n/languages";

const LanguageContext = createContext(null);

function readStored() {
  try {
    const stored = localStorage.getItem("exopilot_language");
    if (stored && translations[stored]) return stored;
  } catch (e) { /* localStorage unavailable */ }
  return DEFAULT_LANGUAGE;
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(readStored);

  const setLanguage = (code) => {
    if (!translations[code]) return;
    setLanguageState(code);
    try { localStorage.setItem("exopilot_language", code); } catch (e) { /* ignore */ }
  };

  useEffect(() => {
    const meta = LANGUAGES.find((l) => l.code === language) || LANGUAGES[0];
    document.documentElement.lang = language;
    document.documentElement.dir = meta.dir;
  }, [language]);

  const t = translations[language] || translations[DEFAULT_LANGUAGE];
  const dir = (LANGUAGES.find((l) => l.code === language) || LANGUAGES[0]).dir;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, dir }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within a LanguageProvider");
  return ctx;
}
